import { css } from '@emotion/react';
import { ZapTemplate } from '@zapier/authentication';
import { Colors, Typography } from '@zapier/design-system';
import { mediaQueries } from '@zapier/identity-utils';

type Props = {
  zapTemplate: ZapTemplate;
};

const titleStyle = css`
  ${Typography.sectionHeader1Extrabold}
  color: ${Colors.gray};
  margin-bottom: 30px;
  text-align: center;

  ${mediaQueries.desktop} {
    ${Typography.pageHeader5}
  }
  ${Typography.pageHeader7}
  color: ${Colors.neutral800};
  ${mediaQueries.desktop} {
    ${Typography.pageHeader5}
  }
`;

export function ZapTemplateTitle({ zapTemplate }: Props) {
  if (
    zapTemplate.tailService &&
    zapTemplate.tailService.name !== zapTemplate.headService.name
  ) {
    return (
      <h1 css={[titleStyle]}>
        Connect {zapTemplate.headService?.name} +{' '}
        {zapTemplate.tailService?.name}
      </h1>
    );
  }

  return <h1 css={titleStyle}>Connect the apps you use every day</h1>;
}
